module.exports = __webpack_public_path__ + "resources/img/sp_main_m.ea7cfac6d1829bd3aedbf2824eaf58f8.png";